export default __webpack_public_path__ + "static/media/aerial-platform-basket.50be74a0.jpg";